import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const quantityConditions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is greater than', value: 'GreaterThan' },
    { label: 'is greater than or equal to', value: 'GreaterThanOrEqual' },
    { label: 'is less than or equal to', value: 'LessThanOrEqual' },
    { label: 'is less than', value: 'LessThan' }
];

class ProductVariantQuantityFilterComponent extends React.Component {
    state = {};

    render() {

        let variantValues = this.props.variants.map(_ => {
            return { label: _, value: _ };
        })
        variantValues = [
            { label: "--- Choose variant ---", value: "" },
            ...variantValues,
        ];

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={variantValues}
                    value={this.props.filter.variantTitle}
                    onChange={(selected) => this.onVariantTitleChange(selected)}
                />
                <Select
                    options={quantityConditions}
                    value={this.props.filter.quantityCondition}
                    onChange={(selected) => this.onQuantityConditionChange(selected)}
                />
                <TextField
                    placeholder="Quantity"
                    type="number"
                    value={this.props.filter.quantity.toString()}
                    onChange={(newValue) => this.onQuantityChange(newValue)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onVariantTitleChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.variantTitle = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onQuantityConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.quantityCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onQuantityChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.quantity = parseInt(newValue);

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductVariantQuantityFilterComponent;
